import React from 'react';
import AdvencedLink from '../Sider/AdvancedLink'
import { Icon } from '../../components';
import './style.less';
import { ILink } from '@components/Sider/interface';

interface ServiceCardProps {
  imgStyle?: React.CSSProperties,
  image?: string,
  title: string,
  alreadyCount: number,
  compStyle?: React.CSSProperties,
  upgradeUrl?: string,
  type?: string,
  unit?: string,
  isOpen?: boolean,
  desc?: string,
  link?: ILink,
  backendIcon?: string,
  backendText?: string,
  newVersionUrl?: string
}

const clsPrefix = "c-service"
const ServiceCard: React.FC<ServiceCardProps> = ({
  imgStyle={},
  image='',
  title='站点',
  alreadyCount=0,
  unit='站点',
  compStyle={},
  upgradeUrl,
  newVersionUrl,
  isOpen=false,
  desc='',
  link={},
  backendIcon='manag',
  backendText='管理后台'
}) => {

  function handleUpgrade() {
    if (upgradeUrl) {
      window.location.href = upgradeUrl;
    }
  }

  return (
    <div className={clsPrefix} style={{...compStyle}}>
      <div className={`${clsPrefix}__image`}>
        <img alt="" src={image} style={{...imgStyle}} />
      </div>
      <div className={`${clsPrefix}__title`}>
        {title}
      </div>
      <div className={`${clsPrefix}__info`}>
        {
          isOpen ? (
            <div>
              您目前已经创建
              <span className={`${clsPrefix}__strong`}>{alreadyCount}</span>
              个{unit}
            </div>
          ) : (
            <div>{desc}</div>
          )
        }
        
      </div>
      <div 
        className={`${clsPrefix}__opt`}
      >
        {    
          upgradeUrl && (    
          <div 
            onClick={() => handleUpgrade()} 
            style={{ paddingRight: '4px', }}
          >
            <Icon 
              name="upgrade" 
              style={{
                marginRight: '8px',
                fontSize: '22px',
              }}
            />
            <span>升级权益</span>
          </div>
          )
        }
        {    
          newVersionUrl && (    
          <div
            className="new-version"
            onClick={() => {
              window.location.href = newVersionUrl;
            }} 
            style={{ paddingRight: '4px' }}
          >
            <Icon 
              name="banben" 
              style={{
                marginRight: '8px',
                fontSize: '22px',
              }}
            />
            <span>进入新版</span>
          </div>
          )
        }
        <AdvencedLink {...link}>
          <div>
            <Icon
              name={backendIcon}
              style={{
                marginRight: '8px',
                fontSize: '20px',
              }}
            />
            <span>进入<span>{backendText}</span></span>
          </div>
        </AdvencedLink>
      </div>
    </div>   
  )
}

export default ServiceCard;